// extracted by mini-css-extract-plugin
export default {"horizontalLine":"SplittedList_horizontalLine__lwlC9","list":"SplittedList_list__+1kWa"};